import React, { useState, useEffect } from 'react';

import recordActions from '../../../actions/recordActions';
import useStartTimer from '../../../utils/hooks/useStartTimer.hook';
import { connect } from '../../StateProvider';

const AutoRefreshButton = ({ timeUntilTimerEnd, btnRefresh, viewSettingsTimer, sceneId }) => {
  useEffect(() => {
    viewSettingsTimer && recordActions.setTimeUntilTimerEnd(sceneId, Date.now() + 10 * 60 * 1001);
  }, []);

  useEffect(() => {
    const dataNow = viewSettingsTimer ? Date.now() + 10 * 60 * 1001 : null;
    recordActions.setTimeUntilTimerEnd(sceneId, dataNow);
  }, [viewSettingsTimer]);

  useStartTimer(timeUntilTimerEnd, viewSettingsTimer, btnRefresh);
  return null;
};

export default connect(
  AutoRefreshButton,
  {
    viewSettings: ['viewSettings', 'catalogs'],
  },
  (props, { viewSettings }) => {
    const catalogViewSettings = viewSettings && viewSettings.getIn([props.catalogId, 'views', props.viewId, props.viewMode]);
    const timeUntilTimerEnd = props.scene && props.scene.get('timeUntilTimerEnd');
    const sceneId = props.scene && props.scene.get('sceneId');
    return {
      viewSettingsTimer: catalogViewSettings && catalogViewSettings.get('timer'),
      sceneId,
      timeUntilTimerEnd,
      ...props,
    };
  },
);
